import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CopyQuoteNavigationState } from 'src/app/models/quote/copy-quote-navigation-state';
import { ReturnPendingQuote } from 'src/app/models/quote/return-pending-quote';
import { SearchResultQuote } from 'src/app/models/search/search-result-quote';
import { GenericAddStepOneModelEnum } from 'src/app/pages/generic-add-step-one/generic-add-step-one-model-enum';

@Component({
  selector: 'app-quote-card',
  templateUrl: './quote-card.component.html',
  styleUrls: ['./quote-card.component.scss'],
})
export class QuoteCardComponent implements OnInit {

  @Input() showCopyOption: boolean = true;
  @Input() showStatus: boolean = true;
  
  model: QuoteCardModel;
  @Input() set quote(obj: SearchResultQuote | ReturnPendingQuote) {
    this.model = {} as QuoteCardModel;
    this.model = Object.assign(this.model, obj);
  }

  constructor(
    private router: Router
  ) { }

  ngOnInit() {}

  copy() {
    this.router.navigate(['select-customer', GenericAddStepOneModelEnum.QUOTE_COPY], {
      state: <CopyQuoteNavigationState>{
        srcQuoteId: this.model.id
      }
    });
  }
}

interface QuoteCardModel {
  id: number;
  description: string;
  status: string;
  creationDate: Date;
  addressId: string;
  addressType: string;
  customer: string;
  created: Date;
  customerAndAddressExist: boolean;
}
